import { configureStore, PreloadedState } from '@reduxjs/toolkit';
import { authApi, authSlice } from '@modules/auth';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { CombinedState } from 'redux';
import { NoInfer } from '@reduxjs/toolkit/dist/tsHelpers';
import { profileApi } from '@modules/account';

const store = configureStore({
  reducer: {
    auth: authSlice.reducer,
    [authApi.reducerPath]: authApi.reducer,
    [profileApi.reducerPath]: profileApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat([
      authApi.middleware,
      profileApi.middleware,
    ]),
});

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default store;

// For testing
export const setupStore = (preloadedState: PreloadedState<CombinedState<NoInfer<RootState>>>) => {
  return configureStore({
    preloadedState,
    reducer: {
      auth: authSlice.reducer,
      [authApi.reducerPath]: authApi.reducer,
    },
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat([authApi.middleware]),
  });
};
